import { render, staticRenderFns } from "./GalleriesList.vue?vue&type=template&id=fc984418&scoped=true&"
import script from "./GalleriesList.vue?vue&type=script&lang=js&"
export * from "./GalleriesList.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesList.vue?vue&type=style&index=0&id=fc984418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc984418",
  null
  
)

export default component.exports